import {useState} from "react";
import {Button,Modal} from "./components/ui";
import {useI18n} from "./i18n";
import guide from "./content/worker-operations.md?raw";

export function WorkerOperationsGuide(){
 const {t}=useI18n();const[open,setOpen]=useState(false);
 return <><Button onClick={()=>setOpen(true)}>{t("Worker operations guide")}</Button>
  <Modal open={open} title={t("Worker operations guide")} onClose={()=>setOpen(false)}>
   <pre style={{whiteSpace:"pre-wrap",overflowWrap:"anywhere",fontFamily:"inherit",lineHeight:1.8}}>{guide}</pre>
  </Modal>
 </>;
}
